/**
 * groupEntity Normalizr Schema
 */

import { schema } from 'normalizr';

const groupEntity = new schema.Entity('groupEntities');

export default groupEntity;
